import styled, { css } from 'styled-components'
import colors from '../../../configuration/colors'
import CheckmarkWhite from '../../../static/images/Skills/checkmark.svg'
import StudentChecksIcon from '../../../static/images/Skills/student_checks.svg'
import MentorChecksIcon from '../../../static/images/Skills/mentor_checks.svg'
import { Caption1, H3Alternate, H5 } from '../../styled/typography/typography'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import ArrowIcon from '../../../static/images/icons/icon_arrow_dark_grey.svg'

const ModalContainer = styled.div`
  min-height: 400px;
  height: auto;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 3px 30px 0 rgba(0,0,0,0.1);
`
const ModalTop = styled(FlexAlignCenter)`
  height: 80px;
  width: 100%;
  padding: 0 30px;
  background: ${props => props.theme.announcementsBackground};
  justify-content: space-between;

  ${H3Alternate} {
    margin-left: 16px;
  }
`
const ModalBody = styled.div`
  position: relative;
  height: auto;
  width: 100%;
  padding: 30px;
  background: ${props => props.theme.selectBackground};
  text-align: left;
`

const CheckmarkSelect = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 9px;
  border-radius: 20px;
  background: transparent;
  border: 2px solid ${props => props.color};
  cursor: pointer;
  transition: background-color .3s, background-image .3s;
  
  &.selected {
    border: none;
    background-repeat: no-repeat;
    background-color: ${props => props.color};
    background-position: 50% 50%;
    background-image: url(${CheckmarkWhite});
    background-size: 14px 9px;
  }
`

const PaginationWrapper = styled(FlexAlignCenter)`
  &:only-child {
    margin: 0 auto;
  }
`

const PaginationDots = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0;
  margin: 0;
`

const PaginationDot = styled.li`
  height: 12px;
  width: 12px;
  margin: 0 10px;
  background: ${colors.rock};
  border-radius: 12px;
  cursor: pointer;
  
  ${props => props.selected && css`
    height: 18px;
    width: 18px;
    margin: 0 7px;
    border-radius: 22px;
    background: ${colors.dove};
    border: 3px solid #C7BCBC;
  `}
`

const PaginationArrow = styled.button`
  height: 30px;
  width: 30px;
  border-radius: 15px;
  margin-${props => props.right ? 'left' : 'right'}: 5px;
  padding: 0;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${props => props.right ? 'flex-end' : 'flex-start'};
  border: none;
  background: transparent;

  &:after {
    content: "";
    height: 18px;
    width: 12px;
    margin: 0 8px;
    background: url(${ArrowIcon}) center no-repeat;
    ${props => props.right && `
      transform: rotate(180deg);
    `};
  }

  &:hover {
    background: ${colors.ash};
  }
`

const ChartHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
`

const SkillMeaning = styled(Caption1)`
  margin-top: 10px;
  font-weight: 400;
  color: ${props => props.theme.caption1color};
`

const StudentChecks = styled(H5).attrs({
  as: 'h5'
})`
  padding-right: 40px;
  background: 100% 50% no-repeat url(${StudentChecksIcon});
  background-size: 26px 18px;
`

const MentorChecks = styled(H5).attrs({
  as: 'h5'
})`
  padding-right: 40px;
  background: 100% 50% no-repeat url(${MentorChecksIcon});
  background-size: 26px 14px;
`

export {
  ModalContainer,
  ModalTop,
  ModalBody,
  CheckmarkSelect,
  PaginationWrapper,
  PaginationArrow,
  PaginationDots,
  PaginationDot,
  ChartHeader,
  SkillMeaning,
  StudentChecks,
  MentorChecks
}
